type Tag = {
  name: string;
};

type TagsScope = "PLANZONE" | "ZONE" | "PROJECT";

const tag: Tag = {
  name: "",
};

export type { Tag, TagsScope };

export { tag };
